import { REFUND_METHOD_CREDITS, REFUND_METHOD_DEFAULT } from '~/consts/refund';

import { RefundMethodOption } from '../../types';

import { RefundMethods, mapRefundMethodToLabel } from './RefundUtils';
import { LoyaltyPointsPaymentCoverage } from './getLoyaltyPointsPaymentCoverage';

export default function getLoyaltyPointsRefundOptions(
  methods: ReadonlyArray<RefundMethods>,
  coverage: LoyaltyPointsPaymentCoverage,
) {
  // Keep credit-only policies intact until their points-refund behaviour is agreed.
  const creditsHidden = coverage === 'full' && methods.includes(REFUND_METHOD_DEFAULT);
  const options = methods
    .filter((method) => !creditsHidden || method !== REFUND_METHOD_CREDITS)
    .map(
      (method): RefundMethodOption => ({
        value: method,
        label:
          method === REFUND_METHOD_CREDITS && coverage === 'partial'
            ? 'Credits & Points'
            : mapRefundMethodToLabel(method),
      }),
    );

  return {
    options,
    creditsHidden,
    notice: creditsHidden
      ? "Paid entirely with Société Points. Select Default to return points. Credits aren't available."
      : undefined,
  };
}
